<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <a-card title="Cadastro Horário de Atendimento">
    <form ref="form" @submit.prevent="submitForm">
      <div class="row">
        <div class="col-md-8">
          <label for="nome">Departamento</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <div class="input-group input-focus">
            <a-auto-complete v-bind:class="{ 'is-invalid': submitted && !registro.departamento.nome }" required v-model:value="registro.departamento.nome" style="width: 200px" @search="pesquisarDepartamentos" class="form-control border-left-0">
              <template v-slot:dataSource>
                <a-select-option v-for="item in departamentos" :key="item.nome" @click="onSelect(item)">
                  {{ item.nome }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label for="nome">Data Inícial</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <a-date-picker show-time type="date" placeholder="Ex: 20/02/2023" style="width: 100%" class="form-control form-input-component" format="DD/MM/yyyy" v-model:value="registro.dataInicial" />
        </div>
        <div class="col-md-4">
          <label for="nome">Data Final</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <a-date-picker show-time type="date" placeholder="Ex: 20/02/2023" style="width: 100%" class="form-control form-input-component" format="DD/MM/yyyy" v-model:value="registro.dataFinal" />
        </div>
      </div>
      <div class="row" style="margin-top: 10px; bottom: 10px">
        <b style="top: 10px; font-size: 20px">Atendimentos</b>
      </div>
      <div class="row">
        <div class="col-md-3">
          <label for="diaSemana">Dia da Semana</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <select class="form-select form-input-component" v-model="atendimento.diaSemana" :disabled="atendimentoEditar !== null ? true : false">
            <option value="DOMINGO">Domingo</option>
            <option value="SEGUNDA">Segunda-feira</option>
            <option value="TERCA">Terça-feira</option>
            <option value="QUARTA">Quarta-feira</option>
            <option value="QUINTA">Quinta-feira</option>
            <option value="SEXTA">Sexta-feira</option>
            <option value="SABADO">Sábado</option>
          </select>
        </div>
        <div class="col-md-3">
          <label for="quantidadeAtendimento">Qte Atendimento</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <input type="number" v-model="atendimento.quantidade" class="form-control form-input-component" id="quantidadeAtendimento" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <label for="horaInicio">Hora de início</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <input type="text" v-model="atendimento.horaInicio" v-mask="'##:##'" class="form-control form-input-component" id="horaInicio" />
        </div>

        <div class="col-md-3">
          <label for="horaFim">Hora final</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <input type="text" v-model="atendimento.horaFim" v-mask="'##:##'" class="form-control form-input-component" id="horaFim" />
        </div>
        <div class="col-md-2">
          <br />
          <button type="button" class="btn btn-primary" @click="selecionarItem">Incluir</button>
        </div>
      </div>
      <br />
      <div class="row" v-show="itensSelecionados.length > 0" style="margin-top: 10px; bottom: 10px">
        <b style="top: 10px; font-size: 20px">Atendimentos do Período de Atendimento</b>
      </div>
      <div class="row" v-show="itensSelecionados.length > 0">
        <div class="col-md-8">
          <a-table :dataSource="itensSelecionados" :columns="columns">
            <template #action="{ record }">
              <a title="Editar" @click="editarItem(record)"><i class="fas fa-edit icon-edit"></i></a>
              &nbsp;&nbsp;
              <a title="Opções" @click="removerItem(record)"><i class="fas fa-trash icon-trash"></i></a>
              &nbsp;
            </template>
          </a-table>
        </div>
      </div>
      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { getListaDepartamento } from '@/components/service/departamentoService';
import { create, getById } from '@/components/service/horarioAtendimentoService';
export default {
  name: 'FormManterDepartamento',
  setup() {
    return {};
  },
  data() {
    return {
      nomePagina: 'Horario Atendimento',
      departamentos: [],
      submitted: false,
      itensSelecionados: [],
      registro: { departamento: { id: null, nome: null } },
      atendimento: { quantidade: null, diaSemana: null, horaInicio: null, horaFim: null },
      atendimentoEditar: null,
      columns: [
        {
          title: 'Dia',
          dataIndex: 'diaSemana',
          key: 'diaSemana',
          slots: { customRender: 'diaSemana' },
        },
        {
          title: 'Qtde. Atendimentos',
          dataIndex: 'quantidade',
          key: 'quantidade',
          slots: { customRender: 'quantidade' },
        },
        {
          title: 'Horário Inicial',
          dataIndex: 'horaInicio',
          key: 'horaInicio',
          slots: { customRender: 'horaInicio' },
        },
        {
          title: 'Horário Final',
          dataIndex: 'horaFim',
          key: 'horaFim',
          slots: { customRender: 'horaFim' },
        },

        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    async cadastrar() {
      //this.v$.$validate()
      if (!this.$refs.form.checkValidity()) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else if (this.itensSelecionados.length == 0) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Você deve incluir pelo menos um atendimento para cadastrar o horário de atendimento!');
      } else if (this.registro.departamento.id === null) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Você deve selecionar o departamento para realizar o cadastro!');
      } else if (this.registro.dataInicial === undefined || this.registro.dataFinal === undefined) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Você deve informar a data inicial e final para realizar o cadastro!');
      } else {
        let registroPost = { ...this.registro };
        registroPost.periodosAtendimento = this.itensSelecionados;
        await create(registroPost).then(() => {
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.itensSelecionados = [];
          this.submitted = true;
          this.registro = { departamento: { id: null, nome: null } };
        });
      }
    },
    async pesquisarDepartamentos(value) {
      if (value.length >= 2) {
        let filtros = { situacao: 'ATIVO', nome: value };
        await getListaDepartamento(filtros).then((response) => {
          this.departamentos = response.data;
        });
      }
    },
    onSelect(value) {
      this.registro.departamento = { id: value.id, nome: value.nome };
    },

    removerItem(record) {
      const index = this.itensSelecionados.indexOf(record);
      if (index > -1) {
        this.itensSelecionados.splice(index, 1);
      }
    },
    editarItem(record) {
      this.atendimento = { ...record };
      this.atendimentoEditar = { ...record };
    },
    selecionarItem() {
      if (this.atendimento.diaSemana !== null && this.atendimento.horaInicio !== null && this.atendimento.horaFim !== null && this.atendimento.quantidade !== null) {
        let itemSelecionado = { ...this.atendimento };
        if (this.atendimentoEditar != null) {
          this.itensSelecionados = this.itensSelecionados.map((i) => (i.diaSemana !== this.atendimentoEditar.diaSemana ? i : itemSelecionado));
          this.atendimento = { quantidade: null, diaSemana: null, horaInicio: null, horaFim: null };
          this.atendimentoEditar = null;
          return;
        }

        let jaContem = this.itensSelecionados.filter(function (item) {
          return item.diaSemana === itemSelecionado.diaSemana;
        });
        if (jaContem.length > 0) {
          openNotification(typesNotification.warning, 'O dia da semana ' + itemSelecionado.diaSemana + ' já está na lista!');
        } else {
          this.itensSelecionados.push(this.atendimento);
          this.atendimento = { quantidade: null, diaSemana: null, horaInicio: null, horaFim: null };
        }
      } else {
        openNotification(typesNotification.warning, 'Você deve preencher todos os campos de atendimento para adicionar na lista!');
      }
    },

    voltar() {
      this.$router.go(-1);
    },
    async carregar() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getById(idUrl);
        this.registro = { ...res.data, id: idUrl };
        if (this.registro.periodosAtendimento) {
          this.itensSelecionados = [...this.registro.periodosAtendimento];
        }
      }
    },
  },
  async created() {
    this.carregar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
